// Per-community visual treatment + helpers (matches design_guidelines.json)
export const THEMES = {
    coders_playground: {
        key: "CODERS_PLAYGROUND",
        accent: "#FF6B00",
        accent2: "#00FF66",
        glow: "rgba(255,107,0,0.35)",
        tag: "FULL PVP",
        tagClass: "bg-danger/10 text-danger border-danger/40",
        gradient: "linear-gradient(135deg, rgba(255,107,0,0.14), rgba(0,255,102,0.06))",
        label: "Coder's Playground",
    },
    haven_and_havoc: {
        key: "HAVEN_HAVOC",
        accent: "#5f7a4e",
        accent2: "#F59E0B",
        glow: "rgba(245,158,11,0.3)",
        tag: "PVE + PURGE",
        tagClass: "bg-emerald-500/10 text-emerald-400 border-emerald-500/40",
        gradient: "linear-gradient(135deg, rgba(63,78,54,0.35), rgba(245,158,11,0.08))",
        label: "Haven & Havoc",
    },
    the_hideout: {
        key: "THE_HIDEOUT",
        accent: "#D9480F",
        accent2: "#8B949E",
        glow: "rgba(217,72,15,0.3)",
        tag: "PVE + MONUMENT PVP",
        tagClass: "bg-orange-500/10 text-orange-400 border-orange-500/40",
        gradient: "linear-gradient(135deg, rgba(48,54,61,0.55), rgba(217,72,15,0.1))",
        label: "The Hideout",
    },
};

export function themeFor(community) {
    return THEMES[community?.theme] || THEMES.the_hideout;
}

export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString(undefined, {
            month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
        });
    } catch {
        return iso;
    }
}

export function timeAgo(iso) {
    if (!iso) return "—";
    const diff = (Date.now() - new Date(iso).getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
}
